module.exports = __webpack_public_path__ + "static/media/delixpress_logo2.eac4bbc7.svg";